import { FormInstance } from 'antd/lib/form';
import { PowerBIEmbed } from 'powerbi-client-react';
import React, { ReactElement, useEffect, useState } from 'react';
import { models } from 'powerbi-client';
import { Row, Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Payer } from '../../shared/models/payer.model';
import ApplicationDetail from '../../shared/services/applicationDetail.service';
interface ICompareMode {
  pbiData: any;
  searchForm: FormInstance;
  sideForm: FormInstance;
  reloadPbi: number;
  isLoading: boolean;
}

const CompareMode = (props: ICompareMode): ReactElement => {
  const appDetail = ApplicationDetail.instance;
  const groupProviders = appDetail?.getGroupProviders();
  const { pbiData, searchForm, reloadPbi, sideForm, isLoading } = props;
  const [isVisible, setIsVisible] = useState(true);

  const { searchCenter, fromMonth, toMonth } =
    searchForm.getFieldsValue(['searchCenter', 'fromMonth', 'toMonth']);
  const { type, searchPayer } = sideForm.getFieldsValue(['type', 'searchPayer']);

  const configuredPayers = useSelector((state: RootState): Payer[] => state?.payerList?.allPayers);

  const getUpdatedFilters = (hospID: any): any[] => {
    const filterToSet: any[] = [];
    if (hospID === 'All') {
      filterToSet.push({
        $schema: 'http://powerbi.com/product/schema#advanced',
        target: {
          table: 'ClaimData',
          column: 'IHXHospitalID',
        },
        operator: 'In',
        values: groupProviders?.map((ele: Payer): any => ele?.key),
      });
    } else {
      filterToSet.push({
        $schema: 'http://powerbi.com/product/schema#advanced',
        target: {
          table: 'ClaimData',
          column: 'IHXHospitalID',
        },
        operator: 'In',
        values: [String(hospID)],
      });
    }
    if (searchPayer) {
      const selectedPayers = configuredPayers?.filter((ele: Payer): boolean => searchPayer?.includes(ele?.uniqueIdentifier));
      if (selectedPayers?.length) {
        filterToSet.push({
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'FinalPayerName',
          },
          operator: 'In',
          values: selectedPayers.map((ele: Payer): any => ele?.uniqueIdentifier),
        });
      }
    }
    if (type) {
      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'CorporateType',
          },
          operator: 'In',
          values: [type],
        },
      );
    }
    if (fromMonth && toMonth) {
      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: 'ClaimData',
            column: 'Claim Submitted Date',
          },
          logicalOperator: 'And',
          conditions: [
            {
              operator: 'GreaterThanOrEqual',
              value: new Date(fromMonth).toJSON(),
            },
            {
              operator: 'LessThan',
              value:  new Date(toMonth).toJSON(),
            },
          ],
        },
      );
    }
    return filterToSet;
  };

  const renderHsopitalChart = (hospId: any): ReactElement => {
    const updatedFilters = getUpdatedFilters(hospId);
    return (
        <PowerBIEmbed
          key={hospId}
          embedConfig={{
            type: 'report',
            id: pbiData?.id,
            embedUrl: pbiData?.embedUrl,
            accessToken: pbiData?.embedToken?.token,
            tokenType: models.TokenType.Embed,
            permissions: models.Permissions.All,
            settings: {
              hideErrors: false,
              filterPaneEnabled: false,
              navContentPaneEnabled: false,
              bookmarksPaneEnabled: false,
              localeSettings: {
                formatLocale: '',
                language: '',
              },
            },
            filters: [...updatedFilters],
          }}
          cssClassName={'core-pbi-dashboard-compare'}
        />
    );
  };

  useEffect((): any => {
    setIsVisible(false);
    setTimeout((): any => { setIsVisible(true); }, 200);
  }, [reloadPbi]);

  return (
    <React.Fragment>
      {
        isLoading ? <Row className="mr-10 ml-10 mt-md mb-md"><Skeleton/></Row> :
          isVisible &&
          <div className="compare-container">
            {
              ((pbiData) ?
              ((searchCenter?.length) ? searchCenter.map((ele: any): any => renderHsopitalChart(ele)) : renderHsopitalChart('All'))
              : null)
            }
          </div>
      }
    </React.Fragment>
  );
};
export default CompareMode;
